export default __webpack_public_path__ + "static/media/ev-3.99814194.png";